import { FC } from "react";

import { Trans } from "@/common/hooks/useTranslate";
import { FormTypography, FormTypographyProps } from "@/forms-design-system/FormTypography";

type RegisteredCharityStatementProps = {
  registeredName: string;
  registrationNumber: string;
  variant?: FormTypographyProps["variant"];
  vibe?: FormTypographyProps["vibe"];
  align?: FormTypographyProps["align"];
};

export const RegisteredCharityStatement: FC<RegisteredCharityStatementProps> = ({
  registeredName,
  registrationNumber,
  variant = "body2",
  vibe = "quiet",
  align = "center",
}) => {
  return (
    <FormTypography variant={variant} vibe={vibe} align={align} sx={{ opacity: 0.6, wordBreak: "break-word" }}>
      <Trans
        space="common"
        i18nKey="registeredCharity.statement"
        components={{ sb: <FormTypography variant={variant} vibe={vibe} fontWeight={700} component="span" /> }}
        values={{ registeredName, registrationNumber }}
      />
    </FormTypography>
  );
};
